var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCargaD(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Capa_2",
    "data-name": "Capa 2",
    viewBox: "0 0 846.25 417.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        font-size: 19px;\n      }\n\n      .cls-1, .cls-2 {\n        font-family: Montserrat-Bold, Montserrat;\n        font-weight: 700;\n      }\n\n      .cls-1, .cls-3 {\n        fill: #f2f2f2;\n      }\n\n      .cls-4 {\n        fill: gray;\n      }\n\n      .cls-5 {\n        fill: none;\n        stroke: #f2f2f2;\n        stroke-miterlimit: 10;\n        stroke-width: 3px;\n      }\n\n      .cls-2, .cls-6 {\n        fill: #fff;\n        font-size: 20.36px;\n      }\n\n      .cls-7 {\n        fill: #ffa25f;\n      }\n\n      .cls-8 {\n        letter-spacing: 0em;\n      }\n\n      .cls-9 {\n        letter-spacing: 0em;\n      }\n\n      .cls-10 {\n        fill: #ed7850;\n      }\n\n      .cls-11 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-12 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-13 {\n        letter-spacing: 0em;\n      }\n\n      .cls-6 {\n        font-family: Montserrat-Medium, Montserrat;\n        font-weight: 500;\n      }\n\n      .cls-14 {\n        letter-spacing: 0em;\n      }\n\n      .cls-15 {\n        letter-spacing: 0em;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 381.49,
    cy: 117.35,
    r: 13.13,
    transform: "translate(91.03 391.1) rotate(-60.4)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 456.72,
    cy: 300.03,
    r: 13.13,
    transform: "translate(-35.04 538.32) rotate(-59.15)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 236.75,
    cy: 212.36,
    r: 13.13,
    transform: "translate(-3.62 420.61) rotate(-82.8)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 559.77,
    cy: 212.36,
    r: 13.13,
    transform: "translate(278.9 741.08) rotate(-82.8)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 559.77,
    cy: 66.14,
    r: 13.13,
    transform: "translate(423.96 613.2) rotate(-82.8)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 607.49,
    cy: 26.9,
    r: 13.13,
    transform: "translate(498.43 625.12) rotate(-82.2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "383.42 143.94 383.42 129.88 379.98 129.88 379.98 143.94 372.58 136.54 370.15 138.97 381.7 150.52 392.82 139.39 390.39 136.96 383.42 143.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "454.79 273.44 454.79 287.49 458.23 287.49 458.23 273.44 465.63 280.84 468.06 278.41 456.51 266.86 445.39 277.98 447.82 280.41 454.79 273.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "301.02 211.04 250.16 211.04 250.16 214.48 301.02 214.48 293.62 221.87 296.05 224.3 307.6 212.76 296.48 201.63 294.05 204.06 301.02 211.04"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 321.34,
    y: 0.49,
    width: 200,
    height: 90,
    rx: 12,
    ry: 12
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(382.32 39.63)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 0,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 15.5,
    y: 0
  }, "gen"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 56.67,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 65.19,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: -5.44,
    y: 24.44
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 10.06,
    y: 24.44
  }, "duanal")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 321.34,
    y: 164.18,
    width: 200,
    height: 90,
    rx: 12,
    ry: 12
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(348.31 216.59)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "MER"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 48.08,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 62.72,
    y: 0
  }, "ADER\xCDA")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(232.52 218.43)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(553.57 218.43)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "4")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 321.34,
    y: 327.55,
    width: 200,
    height: 90,
    rx: 12,
    ry: 12
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(373.92 379.95)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CLIENTE")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 164.18,
    width: 200,
    height: 90,
    rx: 12,
    ry: 12
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(64.32 216.59)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 17.11,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 25.31,
    y: 0
  }, "igen")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 646.25,
    y: 164.18,
    width: 200,
    height: 90,
    rx: 12,
    ry: 12
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(703.74 216.59)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Desti"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 53.6,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    x: 67.53,
    y: 0
  }, "o")), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "382.81 306.58 382.81 276.57 379.37 276.57 379.37 306.58 371.97 299.18 369.54 301.61 381.09 313.16 392.21 302.03 389.78 299.6 382.81 306.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "457.88 110.8 457.88 140.8 461.32 140.8 461.32 110.8 468.72 118.2 471.15 115.76 459.6 104.22 448.48 115.34 450.91 117.77 457.88 110.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "624.04 211.04 573.17 211.04 573.17 214.48 624.04 214.48 616.64 221.87 619.07 224.3 630.62 212.76 619.49 201.63 617.06 204.06 624.04 211.04"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(554.49 72.21)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "3")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(601.4 32.97)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "4")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 646.25,
    y: 0,
    width: 200,
    height: 90,
    rx: 12,
    ry: 12
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(677.51 52.41)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 0,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 14.8,
    y: 0
  }, "segu"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 65.31,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 73.49,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 85.73,
    y: 0
  }, "do"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 112.55,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 120.74,
    y: 0
  }, "a")), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "624.04 64.82 573.17 64.82 573.17 68.26 624.04 68.26 616.64 75.66 619.07 78.09 630.62 66.54 619.49 55.42 617.06 57.85 624.04 64.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "543.22 28.22 594.08 28.22 594.08 24.78 543.22 24.78 550.62 17.38 548.18 14.95 536.64 26.5 547.76 37.62 550.19 35.19 543.22 28.22"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(374.1 123.42)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "4")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(450.61 307.07)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCargaD);
export default __webpack_public_path__ + "static/media/cargaD.994b536fc82b1151018ff4a57343a834.svg";
export { ForwardRef as ReactComponent };